<template>
  <form
    id="app"
    @submit="checkForm"
    action=""
    method="post"
    class="h-100"
    :class="[loading ? 'loading' : '']"
    data-gtm-form-interact-id="0"
  >
    <h2 class="step-title">{{ __("trads.Choose-your-plan") }}</h2>

    <div v-if="Object.keys(errors).length">
      <div
        class="alert alert-danger"
        role="alert"
        v-for="(error, index) in errors"
        :key="index"
      >
        <strong>{{ error }}</strong>
      </div>
    </div>

    <div class="billing-plan">
      <div
        class="segmented-control plan-segment"
        ref="segmentedControl"
        style="min-height: 200px"
      >
        <div id="highlight" ref="highlight"></div>
        <div v-for="(plan, index) in $parent.plans" :key="plan.id">
          <input
            type="radio"
            :value="plan.id"
            :id="'p_' + plan.id"
            name="segmented-control"
            :data-gtm-form-interact-field-id="index"
            v-model="selectedPlan"
          />

          <label
            :for="'p_' + plan.id"
            :ref="'label_' + plan.id"
            :class="{ active: selectedPlan == plan.id }"
          >
            <span class="badge badge-info save-money" v-if="plan.highlighted">
              <h5 v-text="__('trads.percent-saved', { percent: 50 })"></h5>
            </span>

            <div class="round-selector top-selector"></div>

            <div class="plan-sub text-left">
              <div class="period" v-text="plan.period"></div>
              <div class="billing-time" v-text="plan.time"></div>
            </div>
            <div class="right-area" v-text="plan.summary"></div>
          </label>
        </div>
      </div>
      <h3 v-text="__('trads.The-resiliation-is-possible')"></h3>
    </div>

    <button
      type="submit"
      class="d-flex justify-content-center align-items-center mt-4 btn btn-authent btn-lg btn-block cg-submit"
    >
      {{ this.__("trads.Continue") }}
      <img class="next-arrow" src="/img/style/next-arrow.svg" />
    </button>
  </form>
</template>

<script>
export default {
  props: ["selected"],
  data() {
    return {
      loading: null,
      errors: {},
      selectedPlan: false,
    };
  },
  beforeMount() {
    this.selectedPlan = this.selected
      ? this.selected
      : this.$parent.defaultPlan;
  },
  methods: {
    checkForm(e) {
      e.preventDefault();

      this.loading = true;
      this.errors = {};

      if (this.selectedPlan) {
        return this.$parent.nextStep();
      }

      this.loading = false;
      this.errors["plans"] = this.__("trads.please-select-plan");
    },
  },
  watch: {
    selectedPlan(newSelected) {
      let parentPos = this.$refs.segmentedControl.getBoundingClientRect();
      let itemPos =
        this.$refs["label_" + newSelected][0].getBoundingClientRect();

      this.$refs.highlight.style.height =
        this.$refs["label_" + newSelected][0].offsetHeight + "px";

      this.$refs.highlight.style.top = `${itemPos.top - parentPos.top}px`;
      this.$root.$emit("selectedPlan", newSelected);
    },
  },
};
</script>

<style>
.segmented-control div > input {
  display: none;
}
.plan-segment .round-selector {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  margin: 0 10px;
  position: relative;
  top: -50%;
}
.plan-segment .round-selector::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 78%;
  background-color: rgba(255, 255, 255, 0);
  opacity: 0;
}
.plan-segment div > input:checked + label {
  background: linear-gradient(
      120deg,
      rgba(253, 63, 197, 0.06),
      rgba(72, 167, 242, 0.06)
    )
    border-box;
}
.plan-segment div > input:checked + label .round-selector::before {
  background-image: url(/images/picto-check.svg);
  opacity: 1;
  transition: 0.2s;
}

#highlight {
  z-index: -1;
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;

  border-radius: 10px;
  border: 2px solid transparent;
  background: linear-gradient(120deg, rgba(253, 63, 197, 0.82), #48a7f2)
    border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
}
</style>
